import { TTableProps } from "../types/TableView";
import TableView from "../components/TableView";
import EmptyState from "../components/EmptyState";


const AccessoryList = ({searchValue, searchLoading, columns, rows, showPagination, showSearch, showPerPage, paginationData, onPageChange, onPerPageChange, handleSearchParams, searchPlaceholder, showFilter, filters, selectedRows,data }:TTableProps) => { 
   return (
    <div className='card'>
    <TableView
    columns={columns}
    rows={rows}
    data={data}
    selectedRows={selectedRows}
    showFilter={showFilter}
    filters={filters}
    showPagination={showPagination}
    showSearch={showSearch}
    showPerPage={showPerPage}
    paginationData={paginationData}
    onPageChange={onPageChange}
    onPerPageChange={onPerPageChange}
    handleSearchParams={handleSearchParams}
    searchPlaceholder={searchPlaceholder}
    searchLoading={searchLoading}
    searchWidth={"200px"}
     searchValue={searchValue}
    cardHeaderStyle ={"30px"}
    searchComponent={<EmptyState                      
      title="Sorry"
      message="No Accessory Found"
      buttonTitle="Reset"
      image="/media/misc/empty-State.svg"
    />}
  />
    </div>
  );
};

export default AccessoryList;
